import { render } from "./CashierRobuxElement.vue?vue&type=template&id=24f705c0&scoped=true"
import script from "./CashierRobuxElement.vue?vue&type=script&lang=js"
export * from "./CashierRobuxElement.vue?vue&type=script&lang=js"

import "./CashierRobuxElement.vue?vue&type=style&index=0&id=24f705c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f705c0"]])

export default __exports__